import styled, { css } from 'styled-components'

import { muiTheme } from '../../theme'

interface DotProps {
  mt?: number
  mb?: number
  background: string
}

export function Dot({ background, mt, mb }: DotProps) {
  return <Wrap $background={background} $mt={mt} $mb={mb} />
}

const Wrap = styled.span<{ $background: string; $mt?: number; $mb?: number }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;

  ${(p) =>
    p.$background &&
    css`
      background: ${p.$background};
    `};

  ${(p) =>
    p.$mt &&
    css`
      margin-top: ${muiTheme.spacing() * p.$mt}px;
    `};

  ${(p) =>
    p.$mb &&
    css`
      margin-bottom: ${muiTheme.spacing() * p.$mb}px;
    `};
`
